import { render, staticRenderFns } from "./TheMainView.vue?vue&type=template&id=8849b61a&scoped=true&"
import script from "./TheMainView.vue?vue&type=script&lang=js&"
export * from "./TheMainView.vue?vue&type=script&lang=js&"
import style0 from "./TheMainView.vue?vue&type=style&index=0&id=8849b61a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8849b61a",
  null
  
)

export default component.exports